import Vue from 'vue'
import Vuex from 'vuex'
import { canEdit as canEditUser, isViewer as isViewerUser } from '@/session/permissions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || null,
        user: null
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            localStorage.setItem('token', token);
        },
        setUser(state, user) {
            state.user = user;
        },
        clearSession(state) {
            state.token = null;
            state.user = null;
            localStorage.removeItem('token');
            localStorage.removeItem('token_expired');
        }
    },
    actions: {},
    modules: {},
    getters: {
        isAuthUser(state, getters){
            return (state.token !== null);
        },
        loggedUser(state, getters) {
            return state.user;
        },
		getToken(state) {
			return state.token;
		},
		// P-12: ¿el usuario puede editar (admin) o es de solo lectura (viewer)?
		canEdit(state) {
			return canEditUser(state.user);
		},
		isReadOnly(state) {
			return isViewerUser(state.user);
		},
    }
})
